<template>
  <div class="top_navabr">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <button class="navbar-toggler" id="toggleButton" onclick="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="top-nav-content">
          <a
            :data-after="notificationCount" 
            href="#"
            @click="showNotifications"
            class="notification"
            :class="{ 'zero': notificationCount <= 0 }"
            data-bs-toggle="modal"
            data-bs-target="#notification"
            ><i class="fa-solid fa-bell icons"></i
          ></a>
        </div>
        <div id="navbarNav" style="display: none">
          <ul class="navbar-nav nav-2">
            <li>
              <a
                class="nav-link"
                :class="{ active: this.section === 'DashboardPage' }"
                href="/"
                ><i class="fa-solid fa-house icons"></i>Dashboard</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/assistentes"
                :class="{
                  active:
                    this.section === 'AssistantListPage' ||
                    this.section === 'AssistantPage',
                }"
                ><i class="fa-solid fa-user-graduate icons"></i>Assistentes</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/clientes"
                :class="{
                  active:
                    this.section === 'ClientListPage' || this.section === 'ClientPage',
                }"
                ><i class="fa-solid fa-user icons"></i>Clientes</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/projetos"
                :class="{
                  active:
                    this.section === 'ProjectListPage' || this.section === 'ProjectPage',
                }"
                ><i class="fa-solid fa-briefcase icons"></i>Projetos</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/propostas"
                :class="{
                  active:
                    this.section === 'ProposalListPage' ||
                    this.section === 'ProposalPage',
                }"
                ><i class="fa-regular fa-file-lines icons"></i>Propostas</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/aulas-e-mentorias"
                :class="{
                  active:
                    this.section === 'VideoListPage' || this.section === 'VideoPage',
                }"
                ><i class="fa-brands fa-youtube icons"></i>Aulas/mentorias</a
              >
            </li>

            <li>
              <a
                class="nav-link"
                href="/cursos"
                :class="{
                  active:
                    this.section === 'CourseListPage' || this.section === 'ClassPage',
                }"
                ><i class="fa-solid fa-graduation-cap icons"></i>Cursos</a
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {
    section() {
      return this.$store.state.activeSection;
    },
    notifications() {
      return this.$store.state.notifications;
    },
    notificationCount() {
      return this.$store.state.notifications.length;
    },
  },

  methods: {
    async showNotifications() {
      let ctx = this;
      let $modal = $("#notificationsModal");
      let notifications = this.notifications;
      $modal.find(".notification").html('<div class="loading">Carregando...</div>');
      $modal.modal("show");

      $modal.off().on("shown.bs.modal", async function () {
        try {
          if (notifications.length > 0) {
            $modal.find(".notification").html("");
            notifications.forEach((notification) => {
              let n = $(
                '<div class="item">' +
                  '   <div class="sourch">' +
                  '       <img src="/assets/img/notification_mail.png" alt="" />' +
                  '       <div class="text">' +
                  "           <p></p>" +
                  '           <span class="date"></span>' +
                  "       </div>" +
                  "   </div>" +
                  "</div>"
              );

              let t =
                notification.text +
                ' <a class="link" href="' +
                notification.link +
                '">Clique aqui para ver</a>.';
              n.find(".text > p").html(t);

              n.find(".date").text(
                ctx.formatElapsedTime(notification.registration_timestamp)
              );
              n.addClass("active");

              $modal.find(".notification").append(n);
            });
          } else {
            $modal
              .find(".notification")
              .html('<div class="loading">Nenhuma notificação disponível.</div>');
          }
        } catch (err) {
          console.log(err);
          $modal
            .find(".notification")
            .html(
              '<div class="loading text-danger">Erro ao carregar as notificações.<br/>Por favor, tente novamente.<br/>Se o problema persistir, atualize a página.</div>'
            );
        }
      });
    },
  },
};
</script>
